import React, { useState, useEffect, useContext } from 'react';
import JobService from "../../Controller/JobController";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import HelpSite from "../../../Common/HelpLink";
function JobsHistoryPage({ JobID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [JobHistoryList, setJobHistory] = useState([]);
    JobID = localStorage.getItem('JobID');
    const { theme } = useContext(ThemeContext);
    const JobCostID = localStorage.getItem('JobCostID');
    const activeDateFormat = useDateFormat();
    const fetchJobHistory = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobService.JobHistory(redirectCallback, JobID);
            setJobHistory(data);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    useEffect(() => {
        if (JobID > 0) {
            fetchJobHistory();
        }
        else {
            setJobHistory([]);
        }
    }, [JobID, JobCostID]);
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12" style={{ textAlign: 'right' }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className='divTable'>
                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                            <thead>
                                <tr>
                                    <th>Action By</th>
                                    <th>Created/Updated Date</th>
                                    <th>Status History</th>
                                </tr>
                            </thead>
                        </table>
                        <div style={{ maxHeight: "460px", overflow: "auto" }}>
                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <tbody>
                                    {JobHistoryList.map((job, index) => {
                                        // Convert the DateCreated string to a JavaScript Date object
                                        const date = new Date(job.DateCreated);
                                        const formattedTime = date.toLocaleTimeString('en-US', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false, // Use 24-hour format
                                        });
                                        return (
                                            <tr key={job.ID}>
                                                <td>{job.DisplayName}</td>
                                                <td> {formatDateWithFns(job.DateCreated, activeDateFormat)}   {formattedTime}</td>
                                                <td>{job.Description}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default JobsHistoryPage;
